<app-stepper-form
  header="Subdivision or Consolidation"
  subheader="Form 2205"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [isInvalid]="hasShareIssue"
  [form]="stepperForm"
>
  <div class="step-content full-width" [formGroup]="stepperForm">
    <div class="step-content">
      <app-stepper-form-description
        formKey="2205"
        [hidden]="currentStep !== StepsEnum.FormDescription"
      />
    </div>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.ResolutionSubject"
      [hidden]="currentStep !== StepsEnum.ResolutionSubject"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      @for (resolutionSubject of resolutionSubjects; track resolutionSubject) {
        <div class="form-group">
          <app-checkbox
            [label]="resolutionSubject.label"
            [formControlName]="resolutionSubject.key"
          />
        </div>
      }

      @if (resolutionSubjectForm.controls.otherSubject.value) {
        <app-divider margin="24px 0"/>

        <div class="form-group">
          <app-input-number
            label="Section Number"
            formControlName="sectionNumber"
          />
        </div>

        <div class="form-group">
          <app-textarea
            label="Brief Description"
            formControlName="briefDescription"
          />
        </div>
      }
    </section>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.SubdivisionConversionConsolidation"
      [hidden]="currentStep !== StepsEnum.SubdivisionConversionConsolidation"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <app-share-subdivision-conversion-block
        [securityRegistryRecords]="securityRegistryRecords"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [formGroup]="stepperForm.controls[StepsEnum.SubdivisionConversionConsolidation]"
      />

      <div class="resolution-section">
        <app-divider margin="24px 0"/>

        <h1 class="h1-heading">Details of Resolution</h1>

        <div class="form-group">
          <app-textarea
            label="Resolution"
            formControlName="resolutionText"
            [rows]="3"
          />
        </div>
      </div>
    </section>

    <section
      class="step-section w-100"
      [formGroupName]="StepsEnum.Estimate"
      [hidden]="currentStep !== StepsEnum.Estimate"
    >
      <div>
        <h1 class="h1-heading">Share Classes Distribution Estimate</h1>

        <div [hidden]="isEstimateLoading">
          <app-list-grid-client-side
            [rowData]="shareClassesDistributionEstimate"
            [colDefs]="$any(shareClassesDistributionEstimateConfig)"
            [suppressRowClickSelection]="true"
            [paginationPageSize]="20"
            [paginationPageSizeSelector]="true"
            [suppressCellFocus]="true"
          />
        </div>

        <app-loader [loading]="isEstimateLoading"/>
      </div>

      <div>
        <h1 class="h1-heading">Share Types Distribution Estimate</h1>

        <div [hidden]="isEstimateLoading">
          <app-list-grid-client-side
            [rowData]="shareTypesDistributionEstimate"
            [colDefs]="$any(shareTypesDistributionEstimateConfig)"
            [suppressRowClickSelection]="true"
            [paginationPageSize]="20"
            [paginationPageSizeSelector]="true"
            [suppressCellFocus]="true"
          />
        </div>

        <app-loader [loading]="isEstimateLoading"/>
      </div>

      <h1 class="h1-heading">Shareholders + Share Type Distribution Estimate</h1>

      <app-share-estimate-table
        [isEstimateLoading]="isEstimateLoading"
        [estimatedSecurityRegistryRecords]="estimatedSecurityRegistryRecords"
        [exceptColumns]="['Beneficially Hold']"
        [hideSecurityTypeQuantity]="true"
      />
    </section>
  </div>
</app-stepper-form>
